import { Input } from '../../../forms/Input';
import { styled } from '../../styled-components';

export const EditableInput = styled(Input).attrs({
  className: 'EditableTextContainer',
})`
  flex-grow: 1;
  width: auto;
`;
